<!--
 * @description: 首页
 * @param: 
 * @return: 
<a href="Mailto:test@163.com">给我发邮件</a>
-->
<template>
<div class="first-page-container">
	<div class="header-hd">
		<div class="header-hd-content">
			<div class="header-hd-title">
				欢迎使用SHOOIN报修平台
			</div>
			<div>
				<span> 联系我们 </span> 
				<span>400-8989-686 </span> 
				<span> <a href="Mailto:support@shooin.com.cn"> support@shooin.com.cn </a></span>
			</div>
		</div>
		<img src="../assets/images/light/bg_homeTop.png" alt="联系方式:400-8989-686" srcset="">
	</div>
	<echart-header :titleBg="titleBg"></echart-header>
	<echart-main :titleBg="titleBg"></echart-main>
	<footer-tab :titleBg="titleBg"></footer-tab>
</div>
</template>

<script>
	import { reactive, toRefs, onMounted } from "vue";
	import chartPage from "@/pages/ChartReports.vue"
	import echartHeader from "@/pages/firstPage/header.vue"
	import echartMain from "@/pages/firstPage/main.vue"
	import footerTab from "@/pages/firstPage/footer.vue"
	export default {
		name: "firstPage",
		components: {
			chartPage,
			echartHeader,
			echartMain,
			footerTab
		},
		setup(props) {
			let data = reactive({
				titleBg: {
					'font-weight': 'bold',
					background: '#E8E8E8'
				}
			})
			return {
			...toRefs(data),
			}
		}
	}
	// import pagenation from "@/components/pagenation.vue"
	// import popDialog from "@/components/popDialog.vue"
	// import vChart from "@/components/vChart.vue"
	// import vMap from "@/components/vMap.vue"

	// export default {
	// 	name: "firstPage",
	// 	components: {
	// 		pagenation,
	// 		popDialog,
	// 		vChart,
	// 		vMap
	// 	},
	// 	data() {
	// 		return {
	// 			option:{
	// 				series: [{
	// 						type: 'gauge',
	// 						center: ["50%", "60%"],
	// 						startAngle: 200,
	// 						endAngle: -20,
	// 						min: 0,
	// 						max: 60,
	// 						splitNumber: 12,
	// 						itemStyle: {
	// 							color: '#FFAB91'
	// 						},
	// 						progress: {
	// 							show: true,
	// 							width: 30
	// 						},

	// 						pointer: {
	// 							show: false,
	// 						},
	// 						axisLine: {
	// 							lineStyle: {
	// 								width: 30
	// 							}
	// 						},
	// 						axisTick: {
	// 							distance: -45,
	// 							splitNumber: 5,
	// 							lineStyle: {
	// 								width: 2,
	// 								color: '#999'
	// 							}
	// 						},
	// 						splitLine: {
	// 							distance: -52,
	// 							length: 14,
	// 							lineStyle: {
	// 								width: 3,
	// 								color: '#999'
	// 							}
	// 						},
	// 						axisLabel: {
	// 							distance: -20,
	// 							color: '#999',
	// 							fontSize: 20
	// 						},
	// 						anchor: {
	// 							show: false
	// 						},
	// 						title: {
	// 							show: false
	// 						},
	// 						detail: {
	// 							valueAnimation: true,
	// 							width: '60%',
	// 							lineHeight: 40,
	// 							height: '15%',
	// 							borderRadius: 8,
	// 							offsetCenter: [0, '-15%'],
	// 							fontSize: 60,
	// 							fontWeight: 'bolder',
	// 							formatter: '{value} °C',
	// 							color: 'auto'
	// 						},
	// 						data: [{
	// 							value: 20
	// 						}]
	// 					},

	// 					{
	// 						type: 'gauge',
	// 						center: ["50%", "60%"],
	// 						startAngle: 200,
	// 						endAngle: -20,
	// 						min: 0,
	// 						max: 60,
	// 						itemStyle: {
	// 							color: '#FD7347',
	// 						},
	// 						progress: {
	// 							show: true,
	// 							width: 8
	// 						},

	// 						pointer: {
	// 							show: false
	// 						},
	// 						axisLine: {
	// 							show: false
	// 						},
	// 						axisTick: {
	// 							show: false
	// 						},
	// 						splitLine: {
	// 							show: false
	// 						},
	// 						axisLabel: {
	// 							show: false
	// 						},
	// 						detail: {
	// 							show: false
	// 						},
	// 						data: [{
	// 							value: 20,
	// 						}]

	// 					}
	// 				],
	// 			}
	// 		}
	// 	},
	// 	methods: {
	// 		test(parms) {
	// 			// setInterval(function() {
	// 			//     let random = (Math.random() * 60).toFixed(2) - 0;
	// 			//     this.option.series[0].data[0].value = random;
	// 			//     this.option.series[1].data[0].value = random;
	// 			// }, 2000);
	// 		},
	// 		aaa() {
	// 			// this.option = {
	// 			// 	xAxis: {
	// 			// 		type: 'category',
	// 			// 		data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
	// 			// 	},
	// 			// 	yAxis: {
	// 			// 		type: 'value'
	// 			// 	},
	// 			// 	series: [{
	// 			// 		data: [150, 230, 224, 218, 135, 147, 100],
	// 			// 		type: 'line'
	// 			// 	}]
	// 			// }
	// 			this.$refs.map.createMarker(113.139899,27.833312,"test")
	// 		}
	// 	}
	//}
</script>

<style lang="scss" scoped="scoped">

	.first-page-container{
		width:100%;
		height:100%;
		// padding:0 15px;
		// background-color:rgb(245,246,250);
		// display:flex;
		flex-direction:column;

		.header-hd{
			width: 100%;
			height: 200px;
			position: relative;
			margin-bottom: 5px;
			font-family: SourceHanSansCN-Medium;

			.header-hd-content{
				position: absolute;
				top: 54px;
				left: 80px;
				font-size: 32px;
				color: white;
				font-family: hanSan;

				.header-hd-title{
					margin-bottom: 20px;
					margin-left: 100px;
				}

				span{
					// font-family: SourceHanSansCN-Medium;
					font-size: 18px;
					padding-right: 40px;
					padding-left: 30px;
					background: url(../assets/images/icon/icon_tel.png) no-repeat;
					background-size: 20px 20px;
					a{
						text-decoration: none;
    					color: white;
					}
				}
				span:first-child{
					padding-left: 0;
					background: none;
				}
				span:last-child{
					padding-left: 35px;
					background: url(../assets/images/icon/icon_mail.png) no-repeat;
					background-size: 24px 20px;
				}
			}

			img{
				width: 100%;
			}
		}
	}
</style>
